/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Exports API
 * Admin data-export orchestration (ISS-08-015). Small exports build inline; large ones (products / all-board posts) are deferred to the per-minute `exports:run-pending` scheduler and the client polls status.

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Kick off an export for the given entity. Returns state=done immediately for small entities; state=pending when the build was deferred to the scheduler.

 * @summary Request an export
 */
export const GenerateExportParams = zod
    .object({
        entity: zod.enum(["categories", "brands", "products", "users", "posts"]).describe("Entity to export"),
    })
    .strict();

export const generateExportBodyFormatDefault = `xlsx`;
export const generateExportBodyIncludeReviewQuestionsDefault = 1;

export const GenerateExportBody = zod
    .object({
        format: zod.enum(["xlsx", "json"]).default(generateExportBodyFormatDefault),
        board_id: zod
            .enum([
                "review",
                "tiktoks",
                "beauty_news",
                "editorial_reviews",
                "expert_reviews",
                "activities",
                "test_modal",
                "test_modeless",
                "guidance",
            ])
            .optional()
            .describe("posts only — board_id to scope the export to"),
        user_status: zod
            .enum(["active", "inactive", "dummy", "migrated"])
            .optional()
            .describe("users only — status filter"),
        product_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
            .optional()
            .describe("products only — product_status filter"),
        include_review_questions: zod
            .union([zod.literal(0), zod.literal(1)])
            .default(generateExportBodyIncludeReviewQuestionsDefault)
            .describe("posts\/review only — include resolved review-question text"),
    })
    .strict();

export const generateExport200ResponseDataNameMax = 100;

export const GenerateExport200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                state: zod.enum(["idle", "pending", "running", "done", "failed"]),
                name: zod
                    .string()
                    .max(generateExport200ResponseDataNameMax)
                    .optional()
                    .describe("Built file name under storage\/app\/exports\/"),
                url: zod.string().optional().describe("Download URL (admin.export.file) when a file exists"),
                size: zod.union([zod.number(), zod.null()]).optional(),
                mtime: zod.union([zod.number(), zod.null()]).optional().describe("Built file mtime (unix seconds)"),
                message: zod.string().nullish().describe("Failure detail when state=failed"),
                at: zod.string().datetime({ offset: true }).nullish().describe("When this status was last written"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GenerateExport401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GenerateExport403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GenerateExport404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GenerateExport422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GenerateExport500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

/**
 * Current state of the most recent export request for the entity, falling back to whatever file already exists on disk.

 * @summary Poll export status
 */
export const GetExportStatusParams = zod
    .object({
        entity: zod.enum(["categories", "brands", "products", "users", "posts"]).describe("Entity to inspect"),
    })
    .strict();

export const getExportStatus200ResponseDataNameMax = 100;

export const GetExportStatus200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                state: zod.enum(["idle", "pending", "running", "done", "failed"]),
                name: zod
                    .string()
                    .max(getExportStatus200ResponseDataNameMax)
                    .optional()
                    .describe("Built file name under storage\/app\/exports\/"),
                url: zod.string().optional().describe("Download URL (admin.export.file) when a file exists"),
                size: zod.union([zod.number(), zod.null()]).optional(),
                mtime: zod.union([zod.number(), zod.null()]).optional().describe("Built file mtime (unix seconds)"),
                message: zod.string().nullish().describe("Failure detail when state=failed"),
                at: zod.string().datetime({ offset: true }).nullish().describe("When this status was last written"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetExportStatus401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetExportStatus403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetExportStatus404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetExportStatus500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();
